import * as swcHelpers from '@swc/helpers';
import { isDefined } from '@grandvisionhq/utils';
import { mapServerToAccessoriesSpecifications } from '../specification-mappers/map-server-to-accessories-specifications.js';
import { mapServerToVariantBase } from './map-server-to-variant-base.js';

const mapServerToAccessoriesVariant = (serverProduct, slug, locale)=>{
    const { variants: serverVariants  } = serverProduct;
    if (!serverVariants || !serverVariants.length) {
        return;
    }
    const clientVariants = serverVariants.map((serverVariant)=>{
        var ref, ref1, ref2;
        const variantBase = mapServerToVariantBase(serverVariant, serverProduct, slug, locale);
        if (!variantBase) return;
        const otherFacet = serverVariant.variantTypeDetails.color.length === 0 && (serverVariant === null || serverVariant === void 0 ? void 0 : serverVariant.variantTypeDetails.brandModelColorCode) ? serverVariant === null || serverVariant === void 0 ? void 0 : serverVariant.variantTypeDetails.brandModelColorCode : undefined;
        const pricePerUnit = serverVariant.variantTypeDetails.pricePerLiter && {
            currencyCode: (ref = serverVariant.variantTypeDetails.pricePerLiter) === null || ref === void 0 ? void 0 : ref.currencyCode,
            amount: (ref1 = serverVariant.variantTypeDetails.pricePerLiter) === null || ref1 === void 0 ? void 0 : ref1.amount
        } || undefined;
        var ref3;
        return swcHelpers.objectSpread({}, variantBase, {
            pricePerUnit,
            facets: {
                color: serverVariant.variantTypeDetails.color[0],
                other: otherFacet
            },
            channelAvailability: serverVariant.variantTypeDetails.channelAvailability,
            specifications: mapServerToAccessoriesSpecifications(serverVariant, serverProduct.brand),
            isVtoEnabled: false,
            isReservable: false,
            productFeatures: [],
            accessoryType: (ref3 = (ref2 = serverVariant.variantTypeDetails.accessoryType) === null || ref2 === void 0 ? void 0 : ref2.displayName) !== null && ref3 !== void 0 ? ref3 : undefined
        });
    });
    return clientVariants.filter(isDefined);
};

export { mapServerToAccessoriesVariant };
//# sourceMappingURL=map-server-to-accessories-variant.js.map
